import request from "@/utils/request.js"

/**
 * 班组账单中获取发放金额 
 */
export function getfafang(parm){
	return request.get(`/paylog/getfafangsum`,{
		params:parm
	})
}
/**
 * 材料账单获取发放金额 
 */
export function getcailiaozhangdanfafangsum(parm){
	return request.get(`/paylog/getcailiaozhangdanfafangsum`,{
		params:parm
	})
}
/**
 * 获取上一个班组信息 
 */
export function getLastPayGroupInfo(parm){
    return request.get("/paylog/lastinfo",{
        params:parm
    })
}

export function getfafangtongji(parm){
    return request.get("/paylog/tongjiinfo",{
        params:parm
    })
}


export function getList(parm){
    return request.get("/paylog",{
        params:parm
    })
}
export function addmul(parm){
    return request.post("/paylog/addmul",{
        data:parm
    })
}
export function addPl(parm){
    return request.post("/paylog",{
        data:parm
    })
}
export function updatePl(parm){
    return request.put("/paylog",{
        data:parm
    })
}
export function changekaoqindate(parm){
    return request.put("/paylog/changekaoqindate",{
        data:parm
    })
}
export function deletePl(parm){
    return request.delete("/paylog",{
        params:parm
    })
}